import React, { useState } from 'react'
import {
    Button,
    Chip,
    Divider,
    FormControl,
    Input,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    useTheme,
} from '@material-ui/core'
import { Container } from '../../components'
import { useAppDispatch, useInventoryGroup } from '../../hooks'
import { createAreaConfigReq, CreateAreaConfigRequest } from '../../store'
import { toast } from 'react-toastify'
import { AreaType } from '../../models'
import { useMultiSelectStyles } from '../../styles'
import { typographyStyle } from '../../theme/typographyStyle'

interface Props {
    onClose: () => void
}

export const CreateAreaConfigForm = (props: Props) => {
    const theme = useTheme()
    const { inventoryGroups: inventoryGroupList } = useInventoryGroup()

    const [name, setName] = useState('')
    const [validate, setValidate] = useState(false)
    const [areaType, setAreaType] = useState<AreaType>(AreaType.COM)

    const [selectedInvGroupIds, setSelectedInvGroupIds] = useState<number[]>([])

    const dispatch = useAppDispatch()
    const classes = useMultiSelectStyles()

    return (
        <Container style={{ height: 500, width: 500, flexDirection: 'column' }}>
            {/* Title area */}
            <Container style={{ padding: theme.spacing(1) }}>
                <span
                    style={{
                        ...typographyStyle(theme.typography.h5),
                        fontWeight: 700,
                    }}
                >
                    Create Area Config
                </span>
            </Container>
            <Divider />

            <Container
                style={{ flexDirection: 'column', padding: theme.spacing(1) }}
            >
                <TextField
                    variant="outlined"
                    label="Name (Required)"
                    error={validate && name === ''}
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value)
                    }}
                    style={{ marginBottom: theme.spacing(1) }}
                />

                <FormControl
                    style={{ margin: theme.spacing(2, 0), width: '100%' }}
                >
                    <InputLabel id="area-type-label">Area Type</InputLabel>
                    <Select
                        id={`area-type-select`}
                        value={areaType}
                        onChange={(e) => {
                            setAreaType(e.target.value as AreaType)
                        }}
                        label="Area Type"
                        title="Area Type"
                        style={{ width: '100%' }}
                    >
                        {Object.values(AreaType).map((value) => {
                            return (
                                <MenuItem key={value} value={value}>
                                    {value.charAt(0) +
                                        value.substring(1).toLocaleLowerCase()}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>

                <FormControl style={{ marginTop: theme.spacing(2) }}>
                    <InputLabel id="inv_group-chip-label">
                        Inventory Groups (optional)
                    </InputLabel>

                    <Select
                        labelId="lease-chip-label"
                        id="mutiple-chip-lease"
                        multiple
                        value={selectedInvGroupIds}
                        onChange={(
                            event: React.ChangeEvent<{
                                value: unknown
                            }>,
                        ) => {
                            const newSelectedInvGroupIds = event.target
                                .value as number[]
                            setSelectedInvGroupIds(newSelectedInvGroupIds)
                        }}
                        MenuProps={{
                            getContentAnchorEl: () => {
                                return (null as unknown) as Element
                            },
                        }}
                        input={<Input id="select-multiple-chip-lease-tenant" />}
                        renderValue={(selected) => (
                            <div className={classes.chips}>
                                {(selected as number[]).map((value) => {
                                    const invGroup = inventoryGroupList?.find(
                                        (group) => group.id === value,
                                    )

                                    return (
                                        <Chip
                                            key={`INV_GROUP_CHIP_${invGroup?.id}`}
                                            label={invGroup?.name ?? ''}
                                            className={classes.chip}
                                        />
                                    )
                                })}
                            </div>
                        )}
                    >
                        {inventoryGroupList?.map((invGroup) => {
                            return (
                                <MenuItem
                                    key={`INV_GROUP_MENU_ITEM_${invGroup.id}`}
                                    value={invGroup.id}
                                >
                                    {invGroup.name}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            </Container>
            <div style={{ flex: 1 }} />
            <Divider />
            <Container style={{ padding: theme.spacing(1) }}>
                <div style={{ flex: 1 }} />
                <Button
                    variant="outlined"
                    color="secondary"
                    style={{ marginRight: theme.spacing(1) }}
                    onClick={props.onClose}
                >
                    Cancel
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        if (name === '') {
                            setValidate(true)
                            return
                        }

                        const req: CreateAreaConfigRequest = {
                            body: {
                                name: name,
                                area_type: areaType,
                            },
                        }
                        if (selectedInvGroupIds.length > 0) {
                            req.body.inventory_groups = selectedInvGroupIds
                        }

                        dispatch(createAreaConfigReq(req)).then(() => {
                            toast.success(`${name} Created.`)
                            setName('')
                            props.onClose()
                        })
                    }}
                >
                    Create
                </Button>
            </Container>
        </Container>
    )
}
